import { render, staticRenderFns } from "./drifting-cloud.global.vue?vue&type=template&id=774416d2&"
import script from "./drifting-cloud.global.vue?vue&type=script&lang=js&"
export * from "./drifting-cloud.global.vue?vue&type=script&lang=js&"
import style0 from "./drifting-cloud.global.vue?vue&type=style&index=0&id=774416d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports